(ns manatee.info.handlers
  "Info. view event handlers."
  (:require [ajax.core :as ajax]
            [kee-frame.core :as kf]
            [manatee.app-db :as app-db]
            [manatee.components.modal.handlers :as modal]
            [manatee.components.notifications.handlers :as notifications]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::load-info-view
 (fn load-info-view
   [_cofx _event]
   {:http-xhrio {:method :get
                 :uri (kf/path-for [:info])
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success [::load-info-success]
                 :on-failure [::load-info-failure]}}))

(rf/reg-event-db
 ::save-server-version
 (fn save-server-version
   [db [_ server-version]]
   (app-db/set-server-version db server-version)))

(rf/reg-event-fx
 ::load-info-success
 (fn load-info-success
   [_cofx [_ {:keys [server-version]}]]
   {:fx [[:dispatch-n [[::save-server-version server-version]
                       [::modal/show :info-modal]]]]}))

(rf/reg-event-fx
 ::load-info-failure
 (fn load-info-failure
   [_cofx _event]
   {:dispatch [::notifications/add-alert :main
               {:message "Unable to load application info. Refresh the browser to try again or contact support if necessary."
                :type    :error}
               :auto-dismiss? false]}))
